import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingIndicatorModule } from '../loading-indicator/loading-indicator.module';
import { ModalModule } from '../modal/modal.module';
import { LoadingPanelComponent } from './loading-panel.component';

@NgModule({
  imports: [CommonModule, LoadingIndicatorModule, ModalModule],
  declarations: [LoadingPanelComponent],
  exports: [LoadingPanelComponent],
})
export class LoadingPanelModule {}
